export default __webpack_public_path__ + "static/media/photo--lg--kickoff1b.131dc806.jpg";